var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatsSignP(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_797_750)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_797_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91016 1.83333C12.5862 1.83333 15.5768 4.824 15.5768 8.5C15.5768 12.176 12.5862 15.1667 8.91016 15.1667C5.23416 15.1667 2.24349 12.176 2.24349 8.5C2.24349 4.824 5.23416 1.83333 8.91016 1.83333ZM8.91016 0.5C4.49216 0.5 0.910156 4.082 0.910156 8.5C0.910156 12.918 4.49216 16.5 8.91016 16.5C13.3282 16.5 16.9102 12.918 16.9102 8.5C16.9102 4.082 13.3282 0.5 8.91016 0.5ZM12.9102 9.16667H9.57682V12.5H8.24349V9.16667H4.91016V7.83333H8.24349V4.5H9.57682V7.83333H12.9102V9.16667Z",
    fill: "#23D2E2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.910156 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_797_750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.910156 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsSignP);
export default __webpack_public_path__ + "static/media/stats_sign_p.8e9da44600293cb7ba38b4e20dc002b2.svg";
export { ForwardRef as ReactComponent };